/**
 * Cache keys for device types. A type's `device_count` changes whenever a
 * device of that type is created or deleted, or a device's type is set or
 * cleared, so device mutations invalidate {@link deviceTypeQueryKeys.all} too.
 */
export const deviceTypeQueryKeys = {
  all: () => ["deviceTypes"] as const,
  list: (orgId: string | undefined) =>
    [...deviceTypeQueryKeys.all(), "list", orgId] as const,
  detail: (deviceTypeId: string | undefined) =>
    [...deviceTypeQueryKeys.all(), "detail", deviceTypeId] as const,
};
